'use client';

import { useEffect } from 'react';
import { captureKlaviyoParams } from './utils';

/**
 * React hook to automatically capture Klaviyo attribution parameters
 *
 * ⚠️ DO NOT use this directly in app/layout.tsx!
 * Instead, use the <KlaviyoProvider /> component to keep your layout as a server component.
 *
 * This hook captures the _kx parameter from URL query strings for proper attribution.
 *
 * This is CRITICAL for:
 * - Email click attribution
 * - Flow triggers working correctly
 * - Connecting events to the right profile
 *
 * @example
 * ```tsx
 * // ✅ CORRECT: Use KlaviyoProvider in server layout
 * // app/layout.tsx (SERVER component)
 * import { KlaviyoProvider } from '@/lib/klaviyo';
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         <KlaviyoProvider />
 *         {children}
 *       </body>
 *     </html>
 *   );
 * }
 * ```
 *
 * @example
 * ```tsx
 * // ✅ ALSO VALID: Use in client components if needed
 * 'use client';
 * import { useKlaviyoIdentity } from '@/lib/klaviyo';
 *
 * export function MyClientComponent() {
 *   useKlaviyoIdentity();
 *   return <div>...</div>;
 * }
 * ```
 */
export function useKlaviyoIdentity() {
  useEffect(() => {
    captureKlaviyoParams();
  }, []);
}
